var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
// Admin management API. Every endpoint requires the ManageAdmins permission
// server-side; these calls just surface the results / errors to the UI.
export function listAdmins() {
    return client.get('/admins');
}
export function createAdmin(data) {
    return client.post('/admins', data);
}
export function updateAdminPermissions(username, data) {
    return client.patch(`/admins/${encodeURIComponent(username)}`, data);
}
export function deleteAdmin(username) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.delete(`/admins/${encodeURIComponent(username)}`);
    });
}
